import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getDocumentacaoAVCB } from "./services";

interface DocumentoAVCB {
  id: number;
  idUsuario: number;
  idLoja: number;
  idRegional: number;

  enviador: string;
  nomeArquivoUnico: string;
  nomeArquivoOriginal: string;
  tipoArquivo: string;
  caminhoArquivo: string;
  data_Inserido: string;
  data_Vencimento: string;
}

interface UploadState {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
  responseData: DocumentoAVCB[] | null;
}

const initialState: UploadState = {
  status: "idle",
  error: null,
  responseData: null,
};

export const getDocumentacaoAVCBDaApi = createAsyncThunk<
  DocumentoAVCB[],
  { idLoja: number; idRegional: number },
  { rejectValue: string }
>(
  "upload/getDocumentacaoAVCBDaApi",
  async ({ idLoja, idRegional }, { rejectWithValue }) => {
    try {
      const data = await getDocumentacaoAVCB(idLoja, idRegional);
      return data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return rejectWithValue(errorMessage);
    }
  },
);

const sliceGetDocumentacaoAVCB = createSlice({
  name: "getDocumentacaoAVCB",
  initialState,
  reducers: {
    resetGetDocumentacaoAVCBState: (state) => {
      state.status = "idle";
      state.error = null;
      state.responseData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentacaoAVCBDaApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.responseData = null;
      })
      .addCase(
        getDocumentacaoAVCBDaApi.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "success";
          state.responseData = action.payload;
        },
      )
      .addCase(
        getDocumentacaoAVCBDaApi.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload || "Ocorreu um erro desconhecido.";
        },
      );
  },
});

export const { resetGetDocumentacaoAVCBState } =
  sliceGetDocumentacaoAVCB.actions;
export default sliceGetDocumentacaoAVCB.reducer;
